import { Component, Vue } from "vue-property-decorator";
import { i18n } from "@/resources/locales";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { CONFIG, ConfigInterface } from "@/resources/constants/system";
@Component({})
export default class NewMessage extends Vue {
  arrayNotifications = [];
  onNewMessage(name, user, chatType) {
    const config: ConfigInterface = this.$store.getters["UserStore/getConfig"];

    const options = {
      body: i18n
        .t("notifications.newMessage.body", {
          name,
        })
        .toString(),
      image: "https://assets-pro.nubi.city/nubii-us-blue.png",
      icon: "/src/assets/images/logo/nubii_blue.png",
      silent: config.notification.silenceNotification,
    };
    if (document.hidden) {
      const notification = new Notification(
        i18n.t("notifications.newMessage.title").toString(),
        options
      );
      setTimeout(notification.close.bind(notification), 5000);
    }
    let textMessage = "notifications.newMessage.bodyRoom";
    if (chatType == CHAT_TYPE.ROOM)
      textMessage = "notifications.newMessage.bodyRoomRoom";
    if (chatType == CHAT_TYPE.SPACE)
      textMessage = "notifications.newMessage.bodyRoomGeneral";
    const notification = this.$vs.notification({
      border: "primary",
      clickClose: true,
      progress: "auto",
      duration: 16000,
      position: "top-right",
      icon: '<i class="fas fa-envelope" style="color: #2b3d8e"></i>',
      title: i18n.t("notifications.newMessage.title").toString(),
      text: user
        ? i18n
            .t("notifications.newMessage.body", {
              name,
            })
            .toString()
        : i18n
            .t(textMessage, {
              name,
            })
            .toString(),
      onClick: async () => {
        await this.$store.dispatch("SidebarStore/setOpenChatAction", false);
        switch (chatType) {
          case CHAT_TYPE.ONE_TO_ONE: {
            await this.$store.dispatch("ChatStore/setMessagesAction", []);
            await this.$store.dispatch("ChatStore/setUserChatAction", {
              ...user.superSpaceUser,
            });
            await this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
              id: user.superSpaceUser.id,
              type: CHAT_TYPE.ONE_TO_ONE,
            });
            break;
          }
          case CHAT_TYPE.ROOM: {
            await this.$store.dispatch("ChatStore/setMessagesAction", []);
            await this.$store.dispatch("ChatStore/setUserChatAction", null);
            break;
          }
          case CHAT_TYPE.SPACE: {
            await this.$store.dispatch("ChatStore/setMessagesAction", []);
            await this.$store.dispatch("ChatStore/setUserChatAction", null);
            break;
          }
        }
        await this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
          type: chatType,
        });
        await this.$store.dispatch("ChatStore/setChatTypeAction", chatType);
        await this.$store.dispatch("SidebarStore/setOpenChatAction", true);
        await this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
      },
    });
    this.arrayNotifications.push(notification);

    if (this.arrayNotifications.length >= 3) {
      this.arrayNotifications[0].close();
      this.arrayNotifications.splice(0, 1);
    }
  }
}
